(() => {
  if (window.visualShadeGuideInitialized) return;
  window.visualShadeGuideInitialized = true;

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-visual-shade]');
    if (!swatch) return;

    const guide = swatch.closest('[data-visual-shade-guide]');
    if (!guide) return;

    guide.querySelectorAll('[data-visual-shade]').forEach((item) => {
      item.setAttribute('aria-pressed', String(item === swatch));
    });

    const label = guide.querySelector('[data-visual-shade-label]');
    if (label) {
      label.textContent = swatch.dataset.visualShade;
      label.dataset.selected = 'true';
    }
  }, true);
})();
